export default "__VITE_ASSET__mcw_WNy4__"